import { default as tooltipsJson } from '../../resources/Tooltips.json';
import { TooltipFieldName } from './tooltip-field-name';
import { TooltipPageName } from './tooltip-page-name';

export const getTooltipContentByFieldName = (pageName: TooltipPageName, fieldName: TooltipFieldName): string | undefined => {
  const fields = tooltipsJson[pageName] as any;
  if (!fields) return undefined;

  const field = fields[fieldName];
  return field;
}
